import { useCommunityContext } from '@/providers/community-context';
import { RoleGuard } from '@/components/auth/RoleGuard';
import { isAggregatorKind } from '@/lib/community-ui-mode';
import { AdminMembersView } from './components/AdminMembersView';
import { Loader2 } from 'lucide-react';

export function AdminMembersAccess({ children }: { children: React.ReactNode }) {
  const { community } = useCommunityContext();
  const allowedRoles = isAggregatorKind(community.kind) ? ['ADMIN'] : ['ADMIN', 'CREATOR', 'OWNER'];

  return <RoleGuard allowedRoles={allowedRoles}>{children}</RoleGuard>;
}

export default function AdminMembersPage() {
  const { community: currentCommunity, isLoading } = useCommunityContext();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    );
  }

  if (!currentCommunity) {
    return (
      <div className="text-center py-20">
        <h2 className="text-2xl font-bold text-foreground">Community not found</h2>
        <p className="text-muted-foreground">The community you are looking for does not exist.</p>
      </div>
    );
  }

  return <AdminMembersView community={currentCommunity} />;
}
